export default __webpack_public_path__ + "static/media/search.b113a5a9.svg";